export default "__VITE_PUBLIC_ASSET__b387b317__"